import { render, staticRenderFns } from "./HistoryInnerChatInput.vue?vue&type=template&id=3c1eaa32&scoped=true"
import script from "./HistoryInnerChatInput.vue?vue&type=script&lang=js"
export * from "./HistoryInnerChatInput.vue?vue&type=script&lang=js"
import style0 from "./HistoryInnerChatInput.vue?vue&type=style&index=0&id=3c1eaa32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1eaa32",
  null
  
)

export default component.exports